import React, { useMemo } from 'react';
import { useFocusIdx } from 'easy-email-editor';
import { SelectField } from '../../../components/Form';

export const borderStyleOptions = [
  {
    value: 'dashed',
    label: 'Пунктирная',
  },
  {
    value: 'dotted',
    label: 'Пунктирный',
  },
  {
    value: 'solid',
    label: 'Твердый',
  },
  {
    value: 'double',
    label: 'Двойной',
  },
  {
    value: 'ridge',
    label: 'ridge',
  },
  {
    value: 'groove',
    label: 'groove',
  },
  {
    value: 'inset',
    label: 'inset',
  },
  {
    value: 'outset',
    label: 'outset',
  },
];

export function BorderStyle() {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <SelectField
        label='Стиль'
        name={`${focusIdx}.attributes.border-style`}
        options={borderStyleOptions}
      />
    );
  }, [focusIdx]);
}
